<multi-item-selection-component [tableId]="tableId"
                                [columns]="columns"
                                [loading]="!subscription?.closed"
                                [(selectedItems)]="selectedPublicationItems"
                                [items]="items"
                                [disableNextPage]="disableNextPage"
                                selectionTitle="publication items">
</multi-item-selection-component>
